var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRate = function SvgRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.877.346h10.05c.623 0 1.129.5 1.129 1.119v7.934a1.122 1.122 0 01-1.129 1.118H1.877A1.121 1.121 0 01.748 9.4V1.465A1.123 1.123 0 011.877.345zm1.435 12.307a.613.613 0 01-.615-.61c0-.337.276-.61.615-.61h7.18c.34 0 .615.273.615.61a.613.613 0 01-.615.61h-7.18zm8.013-6.944c.106 0 .192-.06.192-.133v-.264c0-.073-.086-.132-.192-.132h-1.53l-.562-1.227c-.028-.071-.133-.113-.236-.094l-.328.003a.18.18 0 00-.204.108l-.817 2.696L6.543 2.91c-.027-.07-.13-.11-.229-.09l-.41.003c-.132 0-.173.09-.173.09l-.825 2.968-.293-.63c-.029-.07-.126-.08-.241-.076l-1.893.004c-.106 0-.192.059-.192.132v.264c0 .074.086.133.192.133h1.523l.564 1.209c.027.07.135.113.24.094l.299-.002c.102.018.218-.039.245-.108l.846-2.734L7.31 7.953c.026.067.129.107.228.09 0 0 .203-.003.323-.003S8 7.887 8 7.887l.9-2.901.287.627c.027.071.133.113.235.093l1.903.003z",
    fill: "#F75C2F"
  })));
};

export default SvgRate;